<app-header></app-header>
<!--Breadcrumb-->
        <section>
            <div class="bannerimg cover-image bg-background3" data-image-src="assets/images/banners/banner2.jpg">
                <div class="header-text mb-0">
                    <div class="container">
                        <div class="text-center">
                            <h1 class="">View Offers</h1>
                            <!--ol class="breadcrumb text-center">
                                <li class="breadcrumb-item"><a href="home.html">Home</a></li>
                                <li class="breadcrumb-item active text-white">My Dashboard</li>
                                <li class="breadcrumb-item active text-white" aria-current="page">My Preferences</li>
                            </ol-->
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!--Breadcrumb-->

        <!--Section-->
        <section class="sptb">
            <div class="container">
                <div class="row">
                    <div class="col-xl-3 col-lg-12 col-md-12">
                        <!-- my account left menu -->
                <app-my-account-left-menu></app-my-account-left-menu>
                <!-- /my account left menu -->
                    </div>
                    <div class="col-xl-9 col-lg-12 col-md-12">
                        <div class="card mb-0">
                            <div class="card-header d-sm-flex title-set">
                                <h3 class="card-title col-md-8">View Offers</h3>
                                <div class="col-md-4">
                                    
                        
                                </div>
              <!--                   <div class="col-md-6">-->
              <!--                   <label class="selectgroup-item mb-md-0">-->
														<!--	<input type="radio" name="value" value="Latest" class="selectgroup-input">-->
														<!--	<span class="selectgroup-button">Latest <i class="fa fa-sort ml-1"></i></span>-->
														<!--</label>-->
														<!--</div>-->
                            </div>
                            <div class="padding_125">
                                <div class="table-responsive">
                                    <table id="short-filter" class="table table-striped table-bordered text-nowrap text-center">
                                        <thead>
                                            <tr>				
                                                <th>Amount</th>
                                                <th>Status</th>
                                                <th>Make Offer Date Time</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let item of carsList">
                                                <td>{{item.amount}}</td>
												<td>{{item.offer_status_text}}<td>
                                                <td>{{item.created_at}}</td>
                                            </tr>                                            
                                        </tbody>
                                    </table>
                                </div>                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
               
                 
    </section>
    <!--/Section-->

    <app-footer></app-footer>
